import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a4f34P7dNxJQJ7tB5zTeu2J", "DrawPanel", undefined);

import { _decorator, Component, Node, v2, v3, Vec2, Line, Graphics, Vec3, UITransform, PhysicsSystem } from 'cc';
import { E_EventType, E_GameState, E_MainLayerType } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var DrawPanel = (_dec = ccclass('DrawPanel'), _dec2 = property(Line), _dec3 = property(Graphics), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DrawPanel, _Component);

  function DrawPanel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "line_ui", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "gh", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isDirty", false);

    _defineProperty(_assertThisInitialized(_this), "_trs", null);

    _defineProperty(_assertThisInitialized(_this), "_isTouch", false);

    _defineProperty(_assertThisInitialized(_this), "_lastTouch", v2());

    _defineProperty(_assertThisInitialized(_this), "_isMoveing", false);

    _defineProperty(_assertThisInitialized(_this), "_showTime", 10);

    _defineProperty(_assertThisInitialized(_this), "_baseLen", 900);

    _defineProperty(_assertThisInitialized(_this), "_rate_ui2game", 0);

    _defineProperty(_assertThisInitialized(_this), "_rateX", 0);

    _defineProperty(_assertThisInitialized(_this), "_rateY", 0);

    return _this;
  }

  var _proto = DrawPanel.prototype;

  _proto.onLoad = function onLoad() {
    this._rate_ui2game = this._baseLen / 7.5 / 4.5;
    this._trs = this.node.getComponent(UITransform);
    App.GameCtrl.line_draw = this.line_ui.node;
  };

  _proto.start = function start() {
    this.node.on(Node.EventType.TOUCH_START, this.touchStart, this);
    this.node.on(Node.EventType.TOUCH_MOVE, this.touchMove, this);
    this.node.on(Node.EventType.TOUCH_END, this.touchEnd, this);
    this.node.on(Node.EventType.TOUCH_CANCEL, this.touchCancel, this); // let angle: number = Math.tan(Math.PI / 8);
    // let w: number = 100 * angle * 2;

    this._rateX = App.DataMgr.vSize_game.width / App.DataMgr.visibleSize.width;
    var rect_gameCam = App.GameCtrl.cam_game.rect;
    this._rateY = App.DataMgr.vSize_game.height / App.DataMgr.visibleSize.height * 1 / rect_gameCam.y; // this.scheduleOnce(() => {
    //     //@ts-ignore
    //     let model = this.line_ui["_model"];
    //     model.setCapacity(150);
    // }, 1);
  };

  _proto.isTouchEnable = function isTouchEnable() {
    return App.GameCtrl.gameState != E_GameState.Over;
  };

  _proto.touchStart = function touchStart(e) {
    if (!this.isTouchEnable()) return;
    App.GameCtrl.pos_cur = [];
    App.GameCtrl.pos_game = [];
    App.EventMgr.handleEvent(E_EventType.Line_Reset);
    this.resetLine_ui();
    this._isTouch = true;

    if (App.GameCtrl.n_guideLine.active) {
      App.GameCtrl.n_guideLine.active = false;
      App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Game);
    }

    if (!PhysicsSystem.instance.enable) {
      PhysicsSystem.instance.enable = true;
      PhysicsSystem.instance.fixedTimeStep = 1 / 60;
      PhysicsSystem.instance.resetAccumulator(0);
      App.GameCtrl.actball(false);
    } // this.pushPos(e.getUILocation())

  };

  _proto.touchMove = function touchMove(e) {
    var _this2 = this;

    if (!this.isTouchEnable()) return;
    this._lastTouch = e.getUILocation();
    this._isMoveing = true;
    this.scheduleOnce(function () {
      _this2._showTime = 10;
      _this2._isMoveing = false;
    });
    this.pushPos(e.getUILocation());
  };

  _proto.touchEnd = function touchEnd(e) {
    if (!this.isTouchEnable()) return;
    this._isTouch = false;
  };

  _proto.touchCancel = function touchCancel(e) {
    if (!this.isTouchEnable()) return;
    this._isTouch = false;
  };

  _proto.pushPos = function pushPos(pos) {
    this.updatePos_ui(v3(pos.x, pos.y, 0));
    this.updatePos_game(v3(pos.x, pos.y, 0));
    this._isDirty = true;
    App.GameCtrl.isLineDirty = true;
  };

  _proto.correctLen = function correctLen(pos, limit) {
    var points_cur = pos;
    if (points_cur.length < 3) return;
    var len_line = limit;
    var len = 0;
    var lenTemp = 0;
    var pos_offset = v3();
    var i = points_cur.length - 1;

    for (; i > 0; i--) {
      Vec3.subtract(pos_offset, points_cur[i], points_cur[i - 1]);
      lenTemp = v2(pos_offset.x, pos_offset.y).length();
      len += lenTemp;

      if (len >= len_line) {
        if (len - len_line > 1) {
          var rate = (len - len_line) / lenTemp;
          points_cur[i - 1] = v3(points_cur[i].x - points_cur[i - 1].x, points_cur[i].y - points_cur[i - 1].y, 0).multiplyScalar(rate).add(points_cur[i - 1]);
        }

        break;
      }
    }

    points_cur.splice(0, i - 1);
  } //更新坐标 - ui
  ;

  _proto.updatePos_ui = function updatePos_ui(pos) {
    var isPush = true;
    var pos_last = App.GameCtrl.pos_cur[App.GameCtrl.pos_cur.length - 1];

    if (pos_last) {
      var pos_offset = v3();
      Vec3.subtract(pos_offset, pos_last, pos);

      if (pos_offset.length() < 5) {
        isPush = false;
      }
    }

    if (isPush) {
      App.GameCtrl.pos_cur.push(pos);
    }

    this.correctLen(App.GameCtrl.pos_cur, this._baseLen);
    App.PosHandler.bezierPos_three(App.GameCtrl.pos_cur, 3);
  } //更新坐标 - 场景
  ;

  _proto.updatePos_game = function updatePos_game(pos) {
    // App.GameCtrl.line_game.getComponent(Line)!.color.color = Color.YELLOW;
    var nodePos = this._trs.convertToNodeSpaceAR(pos);

    var rect_gameCam = App.GameCtrl.cam_game.rect;
    this._rateY = App.DataMgr.vSize_game.height / App.DataMgr.visibleSize.height * 1 / rect_gameCam.y;
    var pos_aim = v3(nodePos.x * this._rateX + App.GameCtrl.cam_game.node.position.x, nodePos.y * this._rateY + App.GameCtrl.cam_game.node.position.y, 0);
    var isPush = true;
    var pos_last = App.GameCtrl.pos_game[App.GameCtrl.pos_game.length - 1];

    if (pos_last) {
      var pos_offset = v3();
      Vec3.subtract(pos_offset, pos_last, pos_aim);

      if (pos_offset.length() < 1) {
        isPush = false;
      }
    }

    if (isPush) {
      App.GameCtrl.pos_game.push(pos_aim);

      if (App.GameCtrl.pos_game.length > 2) {
        var dir = v3();
        Vec3.subtract(dir, App.GameCtrl.pos_game[App.GameCtrl.pos_game.length - 1], App.GameCtrl.pos_game[App.GameCtrl.pos_game.length - 2]);

        for (var i = 1; i < 1; i++) {
          App.GameCtrl.pos_game.push(v3(pos_aim).add(dir.clone().normalize().multiplyScalar(0.0000001 * i)));
        }
      }

      this.correctLen(App.GameCtrl.pos_game, this._rate_ui2game);
      App.PosHandler.bezierPos_three(App.GameCtrl.pos_game, 0.3);
      this.filterPos(App.GameCtrl.pos_game);
    }
  };

  _proto.filterPos = function filterPos(posArr) {
    if (posArr.length < 8) return;
    var pos0 = v2();
    var pos1 = v2();
    var pos2 = v2();
    var dir_10 = v2();
    var dir_21 = v2();
    var radians0 = 0;

    for (var i = 2; i < posArr.length - 4; i++) {
      pos0 = v2(posArr[i - 2].x, posArr[i - 2].y);
      pos1 = v2(posArr[i - 1].x, posArr[i - 1].y);
      pos2 = v2(posArr[i].x, posArr[i].y);
      Vec2.subtract(dir_10, pos1, pos0);
      Vec2.subtract(dir_21, pos2, pos1);
      radians0 = dir_21.signAngle(dir_10);

      if (radians0 < 0.00001 && radians0 > -0.00001) {
        posArr.splice(i - 1, 1);
        i--;
      }
    }
  };

  _proto.resetLine_ui = function resetLine_ui() {
    this.line_ui.positions = [];
  };

  _proto.update = function update(dt) {
    if (App.GameCtrl.gameState == E_GameState.Over) {
      if (this.line_ui.positions.length > 0) this.line_ui.positions = [];
      if (this._isMoveing) this._isMoveing = false;
      if (this._isTouch) this._isTouch = false;
      return;
    } // if (this._isDirty) {


    this._isDirty = false;
    var pos_cur = App.GameCtrl.pos_cur;

    if (pos_cur.length >= 2) {
      this.line_ui.positions = pos_cur;
    } // }
    //定时 -》 清除路线


    if (this._showTime > 0) {
      this._showTime--;
    } else {
      if (pos_cur.length > 5) {
        pos_cur.splice(0, 4);
      } else {
        pos_cur.splice(0, pos_cur.length - 2);
      }
    } //游戏中的路线  


    if (this._isTouch && !this._isMoveing && App.GameCtrl.pos_game.length > 0) {
      App.GameCtrl.isLineDirty = true;
      this.updatePos_game(v3(this._lastTouch.x, this._lastTouch.y, 0));
    }
  };

  return DrawPanel;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "line_ui", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "gh", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();